import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { BEHAVIOR_SELECTION_OPTIONS } from '@/pages/Onboarding/options/BehaviorSelection';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenBehaviorSelection: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'BehaviorSelection',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const behaviorSelection = form.watch('behavior_selection');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['behavior_selection']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        behaviorSelection: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>Behavior pick</OwnAiTitle>
        <OnboardingOptionsList>
          {BEHAVIOR_SELECTION_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={behaviorSelection === option.id}
              control={form.control}
              option={option}
              name="behavior_selection"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`behavior-selection-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
